import React, { useEffect, useState } from 'react';
import { IoMdLock, IoMdPlayCircle, IoMdUnlock } from "react-icons/io";
import { MdPictureAsPdf, MdAudiotrack, MdLaptopChromebook } from "react-icons/md";
import { useLocation, useNavigate } from 'react-router-dom';
import { fetchAudioData, fetchEnrollCourses, fetchPdfData, fetchQuizData, fetchQuizQuestionData, fetchVideoData } from '../../Firebase/Course-fb';
import { useAccessCard } from '../../ContextProvider/Accesscardprovider';
import { getEnrolledData, getUserDocId, isLoggedIn } from '../../Localstorage';
import Toast from '../../Notification/Toast';
import Datanotfound from '../../Helper/Datanotfound';

const Subtopic = () => {
    const navigate = useNavigate();
    const [enrollData, setEnrollData] = useState(null);
    const location = useLocation();
    const { setToast } = useAccessCard();
    const { unit_filter, found } = location.state || {};
    // const [toast, setToast] = useState(null);
    // const unit_filter = location.state;

    const {
        accessCard, accessCallReg,
        accessPdfCard, accessPcode,
        accessAudioCard, accessAcode,
        accessQuizCard, accessQcode,
        setTotalTime, setMarks
    } = useAccessCard();

    useEffect(() => {
        const loadEnrollData = async () => {
            const login = isLoggedIn();
            if (login) {
                const userId = await getUserDocId();
                const data = await fetchEnrollCourses(userId);
                const courseList = data[0]?.course_list || [];
                const filteredData = courseList.map(item => item.subject_code);
                setEnrollData(filteredData);
            }
        };

        loadEnrollData();
    }, []);



    const handleToQuiz = async (quiz_code_list) => {
        setTotalTime(0);
        setMarks(0);
        const quizTopic = await fetchQuizData(quiz_code_list);
        accessQcode(quizTopic);
        accessCard();
        accessQuizCard();
    }

    const handleToPdf = async (pdf_code_list) => {
        const pdf = await fetchPdfData(pdf_code_list);
        accessPcode(pdf);
        accessCard();
        accessPdfCard();
    }

    const handleToVideo = async (video_code_list) => {
        const video = await fetchVideoData(video_code_list);
        navigate('/video-viewer', { state: video });
    }

    const handleToAudio = async (audio_code_list) => {
        const audio = await fetchAudioData(audio_code_list);
        accessAcode(audio);
        accessCard();
        accessAudioCard();
    }

    const showToast = (msg, type) => {
        setToast({ message: msg, type });
    };

    return (
        unit_filter && unit_filter.length > 0 ? (
            <div className='subtopic_container'>
                {unit_filter?.length > 0 && unit_filter.map((item, index) => {
                    const bgcolors = ['#cef1f5', '#d1e6dd', '#f7d7da', '#fff3cd'];
                    const colors = ['#5b8c90', '#5d8d91', '#82545a', '#7d5a49'];

                    const backgroundColor = bgcolors[index % bgcolors.length];
                    const topicColor = colors[index % colors.length];


                    return (
                        <div className='subTopicCard' style={{ backgroundColor }} key={index}>
                            <div style={{ color: topicColor }}>
                                {item.unit_code?.toLowerCase().includes("demo") || found ? (
                                    <IoMdUnlock className='sblockicon' />
                                ) : (
                                    <IoMdLock className='sblockicon' />
                                )}
                                <span className='sbhead'>{index + 1}.{item.topic_name}</span>
                            </div>
                            <div className='subTopicIcon' style={{ color: topicColor }}>

                                {item.quiz_code_list && item.quiz_code_list.length > 0 ? (
                                    <div className='icondiv'><div><MdLaptopChromebook className='sticon'
                                        // onClick={() => { handleToQuiz(item.quiz_code_list) }}

                                        // onClick={() => enrollData?.includes(item.subject_code) && handleToQuiz(item.quiz_code_list)}

                                        // onClick={() => {
                                        //     if (enrollData?.includes(item.subject_code) && item.lock_status === true) {
                                        //         handleToQuiz(item.quiz_code_list);
                                        //     }
                                        // }}

                                        onClick={() => {
                                            if (!isLoggedIn()) {
                                                showToast('Please login to continue', 'warning');
                                                accessCard();
                                                accessCallReg();
                                            } else if (item.unit_code.toLowerCase().includes("demo") || found) {
                                                handleToQuiz(item.quiz_code_list);
                                            }
                                            else {
                                                showToast('Please subscribe our course', 'warning');
                                            }
                                        }}
                                    /></div><span>-{item.quiz_code_list.length}</span></div>
                                ) : (
                                    <></>
                                )}

                                {item.pdf_code_list && item.pdf_code_list.length > 0 ? (
                                    <div className='icondiv'><div><MdPictureAsPdf className='sticon'
                                        // onClick={() => { handleToPdf(item.pdf_code_list); }}
                                        // onClick={() => enrollData?.includes(item.subject_code) && handleToPdf(item.pdf_code_list)}
                                        onClick={() => {
                                            if (!isLoggedIn()) {
                                                showToast('Please login to continue', 'warning');
                                                accessCard();
                                                accessCallReg();
                                            } else if (item.unit_code.toLowerCase().includes("demo") || found) {
                                                handleToPdf(item.pdf_code_list);
                                            } else {
                                                showToast('Please subscribe our course', 'warning');
                                            }
                                        }}
                                    /></div><span>-{item.pdf_code_list.length}</span></div>
                                ) : (
                                    <></>
                                )}

                                {item.video_code_list && item.video_code_list.length > 0 ? (
                                    <div className='icondiv'><div><IoMdPlayCircle className='sticon'
                                        // onClick={() => { handleToVideo(item.video_code_list); }}
                                        // onClick={() => enrollData?.includes(item.subject_code) && handleToVideo(item.video_code_list)}
                                        onClick={() => {
                                            if (!isLoggedIn()) {
                                                showToast('Please login to continue', 'warning');
                                                accessCard();
                                                accessCallReg();
                                            } else if (item.unit_code.toLowerCase().includes("demo") || found) {
                                                handleToVideo(item.video_code_list);
                                            } else {
                                                showToast('Please subscribe our course', 'warning');
                                            }
                                        }}
                                    /></div><span>-{item.video_code_list.length}</span></div>
                                ) : (
                                    <></>
                                )}

                                {item.audio_code_list && item.audio_code_list.length > 0 ? (
                                    <div className='icondiv'><div><MdAudiotrack className='sticon'
                                        // onClick={() => { handleToAudio(item.audio_code_list) }}
                                        // onClick={() => enrollData?.includes(item.subject_code) && handleToAudio(item.audio_code_list)}
                                        onClick={() => {
                                            if (!isLoggedIn()) {
                                                showToast('Please login to continue', 'warning');
                                                accessCard();
                                                accessCallReg();
                                            } else if (item.unit_code.toLowerCase().includes("demo") || found) {
                                                handleToAudio(item.audio_code_list);
                                            } else {
                                                showToast('Please subscribe our course', 'warning');
                                            }
                                        }}
                                    /></div><span>-{item.audio_code_list.length}</span></div>
                                ) : (
                                    <></>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        ) : (
            <Datanotfound />
        )
    );
}

export default Subtopic;
